class DeliveryRegionRoutingCreateController {
    /*@ngInject*/

    constructor(User, $state, CommonLayoutService, RegionRoutingService, LocationZoneService, $scope, SetupService, Modal, $sce, AtmMakesService, ServiceActionPrioritiesService, ActionCodeService, $translate, $timeout) {
        this.User = User;
        this.$sce = $sce;
        this.$state = $state;
        this.$timeout = $timeout;
        this.RegionRoutingService = RegionRoutingService;
        this.LocationZoneService = LocationZoneService;
        this.CommonLayoutService = CommonLayoutService;
        this.SetupService = SetupService;
        this.AtmMakesService = AtmMakesService;
        this.ServiceActionPrioritiesService = ServiceActionPrioritiesService;
        this.ActionCodeService = ActionCodeService;
        this.$translate = $translate;
        this.hasAcl = {};
        this.$scope = $scope;
        this.Modal = Modal;
        this.bulkZones = [];
        this.savingAll = false;
        this.bulkSaveAlert = {
            show: false,
            type: 'success', // 'success' or 'error'
            message: ''
        };

        this.makesLocalLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: '(Select Makes)'
        };
        this.actionsLocalLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: '(Select Actions)'
        };
        this.customersLocalLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: '(Select Customer)'
        };
        this.actionPrioritiesLocalLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: '(Select Action Priority)'
        };

        this.model = {
            branch: User.getUser().branchId,
            loggedInUser: User.getUser(),
            regionRouting: false,
            weekDays: CommonLayoutService.dayOfWeek(),
            selectedDay: 'MONDAY',
            bucketObj: {},
            regionsObj: {},
            locationData: {}
        }
        this.map = '';
        this.location = {
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            process: true,
            bucketExpanded: true
        }
        this.loadinglocationZone = false;
        this.ruleAssignmentConfig = this.getRuleAssignmentConfig();
        this.ruleAssignmentDrag = this.getDefaultRuleAssignmentDrag();
    }

    buildThresholdOptions(labels) {
        return labels.map((label) => ({
            value: parseFloat(/([\d.]+)/.exec(label)[1]),
            label
        }));
    }

    getRuleAssignmentConfig() {
        return {
            activeStatuses: [
                'Active Status',
                'Logged In On Service Mode',
                'Logged In On User Schedule'
            ],
            distances: this.buildThresholdOptions([
                '<=5 Miles',
                '<=10 Miles',
                '<=20 Miles',
                '<=50 Miles',
                '<=100 Miles'
            ]),
            locationPriorities: this.CommonLayoutService.priorityList(),
            makes: [],
            actionCodes: [],
            actionPriorities: [],
            modes: [
                'FLM',
                'SLM'
            ],
            estWorkloads: this.buildThresholdOptions([
                '<=2 Hours',
                '<=4 Hours',
                '<=6 Hours',
                '<=8 Hours',
                '<=10 Hours',
                '<=24 Hours',
                '<=48 Hours',
                '<=72 Hours'
            ]),
            tickets: this.buildThresholdOptions([
                '<=3 Tickets',
                '<=5 Tickets',
                '<=7 Tickets',
                '<=10 Tickets',
                '<=20 Tickets'
            ])
        };
    }

    getDefaultRuleAssignmentDrag() {
        return {
            zoneKey: null,
            dragIndex: null,
            dragOverIndex: null
        };
    }

    nextRuleUid() {
        this._ruleUidCounter = (this._ruleUidCounter || 0) + 1;
        return `rule_uid_${this._ruleUidCounter}`;
    }

    parseRuleJsonArray(value) {
        if (!value) return [];
        if (Array.isArray(value)) return value;
        if (typeof value === 'string') {
            try {
                const parsed = JSON.parse(value);
                if (Array.isArray(parsed)) return parsed;
            } catch (e) {
                // fall through
            }
            if (value.indexOf(',') !== -1) {
                return value.split(',').map(s => s.trim());
            }
            return [value];
        }
        return [value];
    }

    withMissingSelected(options, selectedValues) {
        const missing = selectedValues.filter((value) => !options.some((option) => option.Value === value));
        return options.concat(missing.map((value) => ({ Value: value, Key: String(value), ticked: true })));
    }

    normalizeRuleAssignment(rule = {}, index = 0, zoneKey = null) {
        const cfg = this.ruleAssignmentConfig;
        const zone = zoneKey ? this.model.bucketObj[zoneKey] : null;
        const parsedMakes = this.parseRuleJsonArray(rule.makes);
        const parsedActionCodes = this.parseRuleJsonArray(rule.actionCodes).map(Number);
        const parsedCustomers = this.parseRuleJsonArray(rule.customerIds).map(Number);
        const parsedActionPriorities = this.parseRuleJsonArray(rule.serviceActionPriorityIds).map(Number);

        const normalized = {
            id: rule.id || null,
            _uid: rule._uid || this.nextRuleUid(),
            sequence: rule.sequence || (index + 1),
            assigneeUserId: rule.assigneeUserId || null,
            assigneeUser: rule.assigneeUser || null,
            activeStatus: rule.activeStatus || cfg.activeStatuses[0],
            distanceInMiles: this.readRuleJsonValue(rule.distanceInMiles),
            locationPriority: this.readRuleJsonValue(rule.locationPriority),
            customerIds: parsedCustomers,
            makes: parsedMakes,
            actionCodes: parsedActionCodes,
            serviceActionPriorityIds: parsedActionPriorities,
            mode: this.readRuleJsonValue(rule.mode),
            estWorkloadInHours: this.readRuleJsonValue(rule.estWorkloadInHours),
            totalTicketsAssigned: this.readRuleJsonValue(rule.totalTicketsAssigned),
            isActive: typeof rule.isActive === 'boolean' ? rule.isActive : null,
            isEditing: !!rule.isEditing,
            isSaving: false
        };

        const makesOptions = this.withMissingSelected(cfg.makes.map((make) => ({
            Value: make.Value,
            Key: make.Key,
            ticked: parsedMakes.includes(make.Value)
        })), parsedMakes);

        const actionCodesOptions = this.withMissingSelected(cfg.actionCodes.map((code) => ({
            Value: code.Value,
            Key: code.Key,
            ticked: parsedActionCodes.includes(code.Value)
        })), parsedActionCodes);

        const customerOptions = this.withMissingSelected((((zone && zone.customerOptions) || [])).map((customer) => ({
            Value: customer.Value,
            Key: customer.Key,
            ticked: parsedCustomers.includes(customer.Value)
        })), parsedCustomers);

        const actionPriorityOptions = this.withMissingSelected(cfg.actionPriorities.map((priority) => ({
            Value: priority.Value,
            Key: priority.Key,
            ticked: parsedActionPriorities.includes(priority.Value)
        })), parsedActionPriorities);

        normalized.editModel = (rule.editModel && rule.isEditing)
            ? _.cloneDeep(rule.editModel)
            : {
                assignee: this.getAssigneeObject(normalized.assigneeUserId, rule, zoneKey),
                activeStatus: normalized.activeStatus,
                distanceInMiles: normalized.distanceInMiles,
                locationPriority: normalized.locationPriority,
                customerOptions: customerOptions,
                selectedCustomers: customerOptions.filter(c => c.ticked),
                customerIds: normalized.customerIds,
                makesOptions: makesOptions,
                actionCodesOptions: actionCodesOptions,
                selectedMakes: makesOptions.filter(m => m.ticked),
                selectedActionCodes: actionCodesOptions.filter(a => a.ticked),
                makes: normalized.makes,
                actionCodes: normalized.actionCodes,
                actionPriorityOptions: actionPriorityOptions,
                selectedActionPriorities: actionPriorityOptions.filter(p => p.ticked),
                serviceActionPriorityIds: normalized.serviceActionPriorityIds,
                mode: normalized.mode,
                estWorkloadInHours: normalized.estWorkloadInHours,
                totalTicketsAssigned: normalized.totalTicketsAssigned,
                isActive: typeof rule.isActive === 'boolean' ? rule.isActive : true
            };

        return normalized;
    }

    readRuleJsonValue(value, fallback = null) {
        if (value === undefined) return fallback;
        if (Array.isArray(value)) return value.length ? value[0] : null;
        if (value && typeof value === 'object') {
            if (value.value) return value.value;
            if (value.label) return value.label;
            const firstValue = Object.values(value)[0];
            return firstValue !== undefined ? firstValue : null;
        }
        return value;
    }

    buildRuleAssignmentPayload(rule, indexOrSequence) {
        const sequence = typeof indexOrSequence === 'number'
            ? indexOrSequence + 1
            : undefined;

        const isActive = typeof rule.isActive === 'boolean'
            ? rule.isActive
            : (typeof (rule.editModel && rule.editModel.isActive) === 'boolean' ? rule.editModel.isActive : false);

        return {
            id: rule.id || undefined,
            assigneeUserId: ('assignee' in rule) ? ((rule.assignee && rule.assignee.Value) || null) : (rule.assigneeUserId || null),
            isActive: isActive,
            sequence,
            distanceInMiles: rule.distanceInMiles || null,
            locationPriority: rule.locationPriority || null,
            customerIds: rule.selectedCustomers && rule.selectedCustomers.length ? rule.selectedCustomers.map(c => c.Value) : null,
            makes: rule.selectedMakes && rule.selectedMakes.length ? rule.selectedMakes.map(m => m.Value) : null,
            actionCodes: rule.selectedActionCodes && rule.selectedActionCodes.length ? rule.selectedActionCodes.map(a => a.Value) : null,
            serviceActionPriorityIds: rule.selectedActionPriorities && rule.selectedActionPriorities.length ? rule.selectedActionPriorities.map(p => p.Value) : null,
            mode: rule.mode || null,
            estWorkloadInHours: rule.estWorkloadInHours || null,
            totalTicketsAssigned: rule.totalTicketsAssigned || null
        };
    }

    applyZoneRuleAssignments(zoneKey, rules = []) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const zone = this.model.bucketObj[zoneKey];
        zone.ruleAssignments = (rules || []).map((rule, index) => this.normalizeRuleAssignment(rule, index, zoneKey));
    }

    ensureZoneRuleAssignmentState(zoneKey) {
        if (!this.model.bucketObj[zoneKey]) return;

        if (!Array.isArray(this.model.bucketObj[zoneKey].ruleAssignments)) {
            this.model.bucketObj[zoneKey].ruleAssignments = [];
        }

        if (typeof this.model.bucketObj[zoneKey].showRuleAssignments === 'undefined') {
            this.model.bucketObj[zoneKey].showRuleAssignments = false;
        }

        if (!this.model.bucketObj[zoneKey].rulesPagination) {
            this.model.bucketObj[zoneKey].rulesPagination = {
                pageLimit: 5,
                total: 0
            };
        }

        if (!Array.isArray(this.model.bucketObj[zoneKey].assigneeOptions)) {
            this.model.bucketObj[zoneKey].assigneeOptions = [];
            this.model.bucketObj[zoneKey].totalAssignees = 0;
        }

        if (!Array.isArray(this.model.bucketObj[zoneKey].customerOptions)) {
            this.model.bucketObj[zoneKey].customerOptions = [];
        }
    }


    getNextPendingSequence(zone) {
        const pendingCount = (zone.ruleAssignments || []).filter((r) => !r.id).length;
        return (zone.rulesPagination ? zone.rulesPagination.total : 0) + pendingCount + 1;
    }

    renumberPendingRules(zoneKey) {
        const zone = this.model.bucketObj[zoneKey];
        if (!zone) return;
        let nextSequence = (zone.rulesPagination ? zone.rulesPagination.total : 0) + 1;
        (zone.ruleAssignments || []).forEach((rule) => {
            if (!rule.id) rule.sequence = nextSequence++;
        });
    }

    syncLoadedRuleSequences(zoneKey) {
        const zone = this.model.bucketObj[zoneKey];
        if (!zone || !zone.rulesPagination) return;
        const total = zone.rulesPagination.total;
        zone.ruleAssignments.forEach((rule, index) => {
            if (rule.id) rule.sequence = total - index;
        });
    }

    openRuleAssignmentPanel(zoneKey) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const zone = this.model.bucketObj[zoneKey];
        zone.showRuleAssignments = true;
        zone.rulesLoading = true;

        Promise.all([
            this.loadAssignees('', 0, zoneKey),
            this.loadCustomers(zoneKey)
        ])
            .then(() => this.refreshZoneRulesFromApi(zoneKey))
            .then(() => {
                if (!zone.ruleAssignments.length) {
                    this.addInlineZoneRuleAssignment(zoneKey);
                }
            })
            .finally(() => {
                zone.rulesLoading = false;
            });
    }

    hasEditingRuleAssignment(zoneKey) {
        const zone = this.model.bucketObj[zoneKey];
        if (!zone) return false;
        return (zone.ruleAssignments || []).some((r) => r.isEditing);
    }

    isZoneRuleDragDisabled(zoneKey) {
        const zone = this.model.bucketObj[zoneKey];
        if (!zone) return false;
        return (zone.ruleAssignments || []).some((r) => !r.id || r.isEditing || r.isSaving);
    }

    hasMoreRules(zoneKey) {
        const zone = this.model.bucketObj[zoneKey];
        if (!zone || !zone.rulesPagination) return false;
        const loadedSavedCount = (zone.ruleAssignments || []).filter((r) => r.id).length;
        return loadedSavedCount < zone.rulesPagination.total;
    }

    loadMoreRules(zoneKey) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const zone = this.model.bucketObj[zoneKey];
        if (zone.rulesLoading || zone.rulesLoadingMore || !this.hasMoreRules(zoneKey)) return;
        const offset = zone.ruleAssignments.filter((r) => r.id).length;
        zone.rulesLoadingMore = true;

        this.RegionRoutingService.getLocationZoneRules(zone.locationZoneId, zone.rulesPagination.pageLimit, offset)
            .then((data) => {
                const newRules = (data.results || []).map((rule, i) => this.normalizeRuleAssignment(rule, offset + i, zoneKey));
                zone.ruleAssignments.push(...newRules);
                zone.rulesPagination.total = data.total || zone.rulesPagination.total;
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                zone.rulesLoadingMore = false;
            });
    }

    deleteZoneRuleAssignment(zoneKey, index) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const zone = this.model.bucketObj[zoneKey];
        const rules = zone.ruleAssignments;
        const rule = rules[index];
        if (!rule) return;

        if (!rule.id) {
            rules.splice(index, 1);
            this.renumberPendingRules(zoneKey);
            if (!rules.length) {
                zone.showRuleAssignments = false;
            }
            return;
        }

        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_delete_title'),
            type: 'danger',
            message: this.$translate.instant('common.confirm_delete_message'),
            callback: (({ modal, $scope }) => {
                $scope.loading = true;
                zone.rulesLoading = true;

                this.RegionRoutingService.deleteLocationZoneRule(zone.locationZoneId, rule.id)
                    .then(() => {
                        modal.close();
                        return this.refreshZoneRulesFromApi(zoneKey);
                    })
                    .catch((err) => {
                        $scope.isLoading = false;
                        $scope.loading = false;
                        this.refreshZoneRulesFromApi(zoneKey);
                        if (err && err.data && err.data.message) {
                            this.Modal.errorModal(err.data.message);
                        }
                    })
                    .finally(() => {
                        zone.rulesLoading = false;
                    });
            })
        });
    }

    toggleZoneRuleAssignments(zoneKey) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const zone = this.model.bucketObj[zoneKey];
        if (zone.showRuleAssignments) {
            zone.showRuleAssignments = false;
            this.clearInlineRuleAssignmentDrag();
            return;
        }

        this.openRuleAssignmentPanel(zoneKey);
    }

    updateLocationZoneLocations(zoneKey) {
        const zone = this.model.bucketObj[zoneKey];
        if (!zone || !zone.locationZoneId || zone.syncingZoneLocations) return;

        zone.syncingZoneLocations = true;
        this.RegionRoutingService.syncZoneLocations(zone.locationZoneId)
            .then((data) => {
                this.showBulkAlert('success', `Location zone updated: ${data.added} location(s) added, ${data.removed} removed, ${data.total} total in zone.`);
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                zone.syncingZoneLocations = false;
            });
    }

    addInlineZoneRuleAssignment(zoneKey) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const zone = this.model.bucketObj[zoneKey];
        const rules = zone.ruleAssignments;
        const newRule = this.normalizeRuleAssignment({ sequence: this.getNextPendingSequence(zone) }, rules.length, zoneKey);
        newRule.isEditing = true;
        newRule.editModel = _.cloneDeep(newRule.editModel);
        rules.push(newRule);
        zone.showRuleAssignments = true;
    }

    startEditZoneRuleAssignment(zoneKey, index) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const rule = this.model.bucketObj[zoneKey].ruleAssignments[index];
        if (!rule || rule.isSaving) return;

        const normalized = this.normalizeRuleAssignment(rule, index, zoneKey);
        rule.isEditing = true;
        rule.editModel = normalized.editModel;
    }

    cancelEditZoneRuleAssignment(zoneKey, index) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const rules = this.model.bucketObj[zoneKey].ruleAssignments;
        const rule = rules[index];
        if (!rule || rule.isSaving) return;

        if (!rule.id) {
            rules.splice(index, 1);
            this.renumberPendingRules(zoneKey);
            if (!rules.length) {
                this.model.bucketObj[zoneKey].showRuleAssignments = false;
            }
            return;
        }

        rule.isEditing = false;
        const normalized = this.normalizeRuleAssignment(rule, index, zoneKey);
        rule.editModel = normalized.editModel;
    }

    saveZoneRuleAssignment(zoneKey, index) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const rules = this.model.bucketObj[zoneKey].ruleAssignments;
        const rule = rules[index];
        if (!rule || !rule.editModel || rule.isSaving) return;

        if (!rule.editModel.assignee) {
            this.Modal.errorModal('Assignee is required.');
            return;
        }

        const payload = this.buildRuleAssignmentPayload(rule.editModel, rule.id ? (rule.sequence || (index + 1)) - 1 : undefined);
        const locationZoneId = this.model.bucketObj[zoneKey].locationZoneId;
        rule.isSaving = true;

        const request = rule.id
            ? this.RegionRoutingService.updateLocationZoneRule(locationZoneId, rule.id, payload)
            : this.RegionRoutingService.createLocationZoneRule(locationZoneId, payload);

        request
            .then(() => {
                rule.isSaving = false;
                this.refreshZoneRulesFromApi(zoneKey, rule); // exclude this rule from pendingRules — it's now saved
            })
            .catch((err) => {
                rule.isSaving = false;
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            });
    }

    refreshZoneRulesFromApi(zoneKey, excludeRule = null) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const zone = this.model.bucketObj[zoneKey];
        if (!zone || !zone.locationZoneId) return Promise.resolve();

        const pendingRules = (zone.ruleAssignments || []).filter(r => !r.id && r !== excludeRule);
        const existingRules = zone.ruleAssignments || [];

        const loadedCount = Math.max(zone.rulesPagination.pageLimit, existingRules.filter(r => r.id).length);

        return this.RegionRoutingService.getLocationZoneRules(zone.locationZoneId, loadedCount, 0)
            .then((data) => {
                const rules = (data.results || []);

                rules.forEach(rule => {
                    const match = existingRules.find(r => r.id === rule.id);
                    if (match && match.isEditing && match !== excludeRule) {
                        rule.isEditing = true;
                        rule.editModel = match.editModel;
                    }
                });

                this.applyZoneRuleAssignments(zoneKey, rules);
                zone.rulesPagination.total = data.total || 0;

                if (pendingRules.length) {
                    this.model.bucketObj[zoneKey].ruleAssignments.push(...pendingRules);
                    this.renumberPendingRules(zoneKey);
                }

                zone.savedRuleCount = zone.rulesPagination.total;
                zone.showRuleAssignments = true;
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            });
    }

    startInlineRuleAssignmentDrag(zoneKey, index) {
        this.ruleAssignmentDrag.zoneKey = zoneKey;
        this.ruleAssignmentDrag.dragIndex = index;
        this.ruleAssignmentDrag.dragOverIndex = index;
    }

    setInlineRuleAssignmentDragOver(zoneKey, index) {
        if (this.ruleAssignmentDrag.zoneKey !== zoneKey || this.ruleAssignmentDrag.dragIndex === null) return;
        this.ruleAssignmentDrag.dragOverIndex = index;
    }

    dropInlineRuleAssignment(zoneKey, index) {
        const fromIndex = this.ruleAssignmentDrag.dragIndex;
        if (this.ruleAssignmentDrag.zoneKey !== zoneKey) {
            this.clearInlineRuleAssignmentDrag();
            return;
        }

        if (fromIndex === null || fromIndex === index) {
            this.clearInlineRuleAssignmentDrag();
            return;
        }

        const rules = this.model.bucketObj[zoneKey].ruleAssignments;

        if (rules.some((rule) => !rule.id || rule.isEditing || rule.isSaving)) {
            this.clearInlineRuleAssignmentDrag();
            return;
        }

        const movedRule = rules.splice(fromIndex, 1)[0];
        rules.splice(index, 0, movedRule);
        this.syncLoadedRuleSequences(zoneKey);
        this.clearInlineRuleAssignmentDrag();
        this.persistZoneRuleSequences(zoneKey);
        this.scrollRuleRowIntoView(movedRule);
    }

    // The scrollable rule list only shows a handful of rows at a time, so a row
    // dropped near the top or bottom of the loaded set can easily land outside the
    // visible area. $timeout (rather than acting immediately) waits for the digest
    // that applies the reorder to the DOM before we go looking for the row.
    scrollRuleRowIntoView(rule) {
        const rowId = rule && (rule.id || rule._uid);
        if (!rowId) return;

        this.$timeout(() => {
            const el = document.getElementById(`zone-rule-row-${rowId}`);
            if (el && typeof el.scrollIntoView === 'function') {
                el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        });
    }

    clearInlineRuleAssignmentDrag() {
        this.ruleAssignmentDrag = this.getDefaultRuleAssignmentDrag();
    }

    persistZoneRuleSequences(zoneKey) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const zone = this.model.bucketObj[zoneKey];
        const rules = zone.ruleAssignments || [];

        if (!rules.length) return Promise.resolve();
        if (rules.some((rule) => !rule.id || rule.isEditing || rule.isSaving)) return Promise.resolve();

        const locationZoneId = zone.locationZoneId;
        const payload = rules.map((rule) => ({ id: rule.id, sequence: rule.sequence }));

        zone.rulesLoading = true;
        return this.RegionRoutingService.reorderLocationZoneRules(locationZoneId, payload)
            .then(() => {
                this.refreshZoneRulesFromApi(zoneKey);
            })
            .catch((err) => {
                this.refreshZoneRulesFromApi(zoneKey);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                zone.rulesLoading = false;
            });
    }

    getAssigneeObject(assigneeId, rule = {}, zoneKey = null) {
        const zone = zoneKey ? this.model.bucketObj[zoneKey] : null;
        const found = ((zone && zone.assigneeOptions) || []).find((item) => item.Value === assigneeId);
        if (found) return found;

        if (assigneeId) {
            const user = rule.assigneeUser || {};
            return {
                Value: assigneeId,
                Key: user.firstName ? `${assigneeId} | ${user.firstName} ${user.lastName}` : (rule.userName ? `${assigneeId} | ${rule.userName}` : (rule.userKey || assigneeId))
            };
        }
        return null;
    }

    getActionCodeObject(actionCodeId) {
        return this.ruleAssignmentConfig.actionCodes.find((item) => item.Value === actionCodeId) || null;
    }

    getMakeObject(makeId) {
        return this.ruleAssignmentConfig.makes.find((item) => item.Value === makeId) || null;
    }

    loadRuleAssignmentOptions() {
        return Promise.all([
            this.AtmMakesService.all('', 0, 1000),
            this.ServiceActionPrioritiesService.all(null, 0, 1000),
            this.ActionCodeService.all('', 0, 1000)
        ])
            .then(([atmMakeData, priorityData, actionCodesData]) => {
                this.ruleAssignmentConfig.makes = (atmMakeData.results || [])
                    .filter((item) => item.active)
                    .map((item) => ({
                        Value: item.vendorName,
                        Key: item.vendorName
                    }));
                this.ruleAssignmentConfig.totalMakes = atmMakeData.totalRecords || this.ruleAssignmentConfig.makes.length;

                this.ruleAssignmentConfig.actionCodes = (actionCodesData.results || []).map((code) => ({
                    Value: code.id,
                    Key: `${code.code} | ${code.label}`
                }));

                this.ruleAssignmentConfig.actionPriorities = (priorityData.results || [])
                    .filter((item) => item.active)
                    .map((item) => ({ Value: item.id, Key: item.priority }));
            })
            .catch((err) => {
                console.log(err);
                this.ruleAssignmentConfig.makes = [];
                this.ruleAssignmentConfig.actionCodes = [];
                this.ruleAssignmentConfig.actionPriorities = [];
            });
    }

    loadAssignees(searchKey, offset, zoneKey) {
        searchKey = searchKey || '';
        this.ensureZoneRuleAssignmentState(zoneKey);
        const zone = this.model.bucketObj[zoneKey];
        if (!zone || !zone.locationZoneId) return Promise.resolve();

        return this.RegionRoutingService.getAssignableUsersForZone(zone.locationZoneId, searchKey, 10, offset)
            .then((data) => {
                const mapped = (data.results || []).map((user) => ({
                    Value: user.id,
                    Key: user.id + " | " + user.firstName + " " + user.lastName
                }));

                if (offset === 0 || offset == undefined) {
                    zone.totalAssignees = data.total;
                    zone.assigneeOptions = mapped;
                } else {
                    zone.assigneeOptions = (zone.assigneeOptions || []).concat(mapped);
                }
            });
    }

    loadCustomers(zoneKey) {
        this.ensureZoneRuleAssignmentState(zoneKey);
        const zone = this.model.bucketObj[zoneKey];
        if (!zone || !zone.locationZoneId) return Promise.resolve();

        return this.RegionRoutingService.getAssignableCustomersForZone(zone.locationZoneId, '', 1000, 0)
            .then((data) => {
                zone.customerOptions = (data.results || []).map((customer) => ({
                    Value: customer.id,
                    Key: `${customer.id} | ${customer.name}`
                }));
            });
    }

    showBulkAlert(type, message) {
        this.bulkSaveAlert = {
            show: true,
            type: type,
            message: this.$sce.trustAsHtml(message)
        };
        
        // Auto-hide success alerts after 5 seconds
        if (type === 'success') {
            setTimeout(() => {
                this.$scope.$apply(() => {
                    this.closeBulkAlert();
                });
            }, 5000);
        }
    }

    closeBulkAlert() {
        this.bulkSaveAlert.show = false;
        this.bulkSaveAlert.message = '';
    }
    saveForAllDays() {
        if (!this.bulkZones.length) {
            this.showBulkAlert('error', "No changes to save for all days.");
            return;
        }
        
        this.savingAll = true;
        this.closeBulkAlert(); // Hide any existing alerts

        const payload = {
            loggedInUser: this.model.loggedInUser,
            branch: this.model.branch,
            zones: this.bulkZones,
            daysToExclude: [this.model.selectedDay]
        };

        this.RegionRoutingService.bulkAllDaySaveLocationZones(payload)
            .then((response) => {
                const results = response.results || {};
                let msg = "";

                // Success summary
                if (results.created && results.created.length) {
                    msg += `<strong>Created:</strong> ${results.created
                        .map((z) => `${z.zone} (${z.successfulDays}/${z.totalDays} days)`)
                        .join(", ")}.<br>`;
                }
                if (results.updated && results.updated.length) {
                    msg += `<strong>Updated:</strong> ${results.updated
                        .map((z) => `${z.zone} (${z.successfulDays}/${z.totalDays} days)`)
                        .join(", ")}.<br>`;
                }
                if (results.deleted && results.deleted.length) {
                    msg += `<strong>Deleted:</strong> ${results.deleted
                        .map((z) => `${z.zone || z.name} (${z.successfulDays}/${z.totalDays} days)`)
                        .join(", ")}.<br>`;
                }

                // Show success or error based on whether there were errors
                if (results.errors && results.errors.length) {
                    msg += "<strong>Errors:</strong><br>" +
                        results.errors
                            .map((e) => `${e.action.toUpperCase()} ${e.zone}${e.day ? " (" + e.day + ")" : ""}: ${e.error}`)
                            .join("<br>");
                    this.showBulkAlert('error', msg);
                } else {
                    this.showBulkAlert('success', msg || "Zones saved for all days successfully!");
                }

                this.bulkZones = [];
            })
            .catch(() => {
                this.showBulkAlert('error', "Failed to save zones for all days");
            })
            .finally(() => {
                this.savingAll = false;
                this.dayChanged();
                this.getLocationZoneCount();
            });
    }
    $onInit() {
        this.model.selectedDay = 'MONDAY';
        Promise.all([
            this.SetupService.get(this.model.branch),
            this.loadRuleAssignmentOptions()
        ])
            .then(([data]) => {
                this.loadMap();
                this.branchDetails(data);
                this.dayChanged();
                this.getLocationZoneCount();
            })
            .catch((err) => {
                this.Modal.errorModal('error.' + err.data.message);
            })
    }

    selectDay(day) {
        this.model.selectedDay = day.value;
        this.dayChanged();
        this.bulkZones = [];
        this.closeBulkAlert();
    }

    loadMap() {
        this.map = L.map('map', {
            center: [39.3684121, -76.7991077],
            zoom: 8,
            editable: true
        });

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);

        // L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
        //     // attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
        //     // maxZoom: 19
        // }).addTo(this.map);

        // L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
        //     // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        //     subdomains: 'abcd',
        //     maxZoom: 19
        // }).addTo(this.map);

        this.editableLayers = new L.FeatureGroup();
        this.map.addLayer(this.editableLayers);

        // const MyCustomMarker = L.Icon.extend({
        //     options: {
        //         shadowUrl: null,
        //         iconAnchor: new L.Point(12, 12),
        //         iconSize: new L.Point(24, 24),
        //         iconUrl: '../client/app/assets/images/marker-icon.png'
        //     }
        // });

        const options = {
            position: 'topleft',
            draw: {
                polyline: {
                    shapeOptions: {
                        // color: '#013220',
                        weight: 3
                    }
                },
                polygon: {
                    allowIntersection: false, // Restricts shapes to simple polygons
                    drawError: {
                        // color: '#e1e100', // Color the shape will turn when intersects
                        message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
                    },
                    shapeOptions: {
                        // color: '#bada55'
                    }
                },
                circle: false,
                rectangle: {
                    shapeOptions: {
                        clickable: true
                    }
                },
                marker: false,
                circlemarker: false
                // marker: {
                //     icon: new MyCustomMarker()
                // }
            },
            edit: {
                featureGroup: this.editableLayers, //REQUIRED!!
                remove: true
            }
        };

        L.EditToolbar.Delete.include({ // remove "CLEAR ALL" button from toolbar 
            removeAllLayers: false
        });

        const drawControl = new L.Control.Draw(options);

        this.map.addControl(drawControl);

        this.map.on(L.Draw.Event.CREATED, (e) => {
            const type = e.layerType,
                layer = e.layer;

            if (type === 'marker') {
                layer.bindPopup('A popup!');
            }

            this.editableLayers.addLayer(layer);

            const content = document.createElement("input");
            content.setAttribute("type", "text");

            const feature = this.editableLayers.feature = this.editableLayers.feature || {};
            feature.type = "Feature";
            feature.properties = feature.properties || {};
            feature.properties[type] = {};

            content.addEventListener('keyup', (event) => {
                feature.properties[type]['name'] = content.value;

                // console.log('event.key, inserted_row.length = ', this.previousTitle, event.key);
                // console.log('this.model.regionsObj = ', this.model.regionsObj);
                // console.log('this.model.bucketObj = ', this.model.bucketObj);
                if (event.key === 'Enter') {
                    event.preventDefault();
                    layer.closePopup();

                    this.model.regionsObj[feature.properties[type]['name']] = {
                        latDetails: {},
                        longDetails: {}
                    };

                    this.model.bucketObj[feature.properties[type]['name']] = {
                        pagination: {
                            page: 1,
                            total: 0,
                            pageLimit: 10,
                            maxPages: 10
                        },
                        gettingBranch: false,
                        searchText: null,
                        process: true,
                        type: type, 
                        zone: feature.properties[type]['name'],
                        ruleAssignments: [],
                        showRuleAssignments: false
                    }

                    if (type === 'rectangle' || type === 'polyline' || type === 'polygon') {
                        let latLong = layer.getLatLngs();
                        let minMaxLat = this.findMinMaxLat(type !== 'polyline' ? latLong[0] : latLong);
                        let minMaxLong = this.findMinMaxLong(type !== 'polyline' ? latLong[0] : latLong);

                        this.model.regionsObj[feature.properties[type]['name']].latDetails.min = minMaxLat.lowest;
                        this.model.regionsObj[feature.properties[type]['name']].latDetails.max = minMaxLat.highest;
                        this.model.regionsObj[feature.properties[type]['name']].longDetails.min = minMaxLong.lowest;
                        this.model.regionsObj[feature.properties[type]['name']].longDetails.max = minMaxLong.highest;
                        // console.log('>>>>> ENTER >', this.model, feature.properties[type]);
                        this.createLocationZone(feature.properties[type]['name'], layer, type, type !== 'polyline' ? latLong : new Array(latLong));
                    }
                } /* else if (event.key === 'Enter') {
                    event.preventDefault();
                    layer.closePopup();
                    this.$scope.$apply(() => {
                        let latLong = layer.getLatLngs();
                        let minMaxLat = this.findMinMaxLat(type !== 'polyline' ? latLong[0] : latLong);
                        let minMaxLong = this.findMinMaxLong(type !== 'polyline' ? latLong[0] : latLong);
                        this.model.regionsObj[feature.properties[type]['name']].latDetails.min = minMaxLat.lowest;
                        this.model.regionsObj[feature.properties[type]['name']].latDetails.max = minMaxLat.highest;
                        this.model.regionsObj[feature.properties[type]['name']].longDetails.min = minMaxLong.lowest;
                        this.model.regionsObj[feature.properties[type]['name']].longDetails.max = minMaxLong.highest;
                        this.model.bucketObj[feature.properties[type]['name']].pagination.page = 1;
                        this.updateLocationZone(feature.properties[type]['name'], layer);
                    });
                } */
            });

            layer.on('popupclose', (e) => {
                if (!feature.properties[type]['name']) return;
                layer.bindTooltip(feature.properties[type]['name'], {
                    permanent: true,
                    direction: 'top',
                });

                this.$scope.$apply(() => {
                    if (this.model.bucketObj.hasOwnProperty(this.previousTitle) && this.model.regionsObj.hasOwnProperty(this.previousTitle)
                        && this.previousTitle !== feature.properties[type]['name']) {
                        this.model.bucketObj[feature.properties[type]['name']] = this.model.bucketObj[this.previousTitle];
                        this.model.regionsObj[feature.properties[type]['name']] = this.model.regionsObj[this.previousTitle];
                        this.model.bucketObj[feature.properties[type]['name']].details.title = feature.properties[type]['name'];
                        delete this.model.regionsObj[this.previousTitle];
                        delete this.model.bucketObj[this.previousTitle];
                    }
                });
            });

            layer.on('popupopen', () => {
                layer.closeTooltip();
                this.previousTitle = _.cloneDeep(feature.properties[type]['name'])
                feature.properties[type]['name'] = content.value;
                content.focus();
            });


            // layer.on('move', () => { // TODO: better solution for this
            //     console.log('Test', this.model.regionsObj)
            // })


            setTimeout(() => {
                layer.bindPopup(content).openPopup();
            }, 100);
        });

        this.map.on(L.Draw.Event.EDITED, (e) => {
            let layers = e.layers;
            layers.eachLayer((layer) => {
                let shape, title;
                if (layer instanceof L.Rectangle) shape = 'rectangle';
                else if (layer instanceof L.Polygon) shape = 'polygon';
                else if (layer instanceof L.Polyline) shape = 'polyline';

                if (layer._popup && layer._popup._content) {
                    title = layer._popup._content;
                    this.model.regionsObj[title] = {
                        latDetails: {},
                        longDetails: {}
                    };

                    let latLong = layer.getLatLngs();
                    let originalLatLong = this.model.bucketObj[title].actualLatLong;
                    let minMaxLat = this.findMinMaxLat(shape !== 'polyline' ? latLong[0] : latLong);
                    let minMaxLong = this.findMinMaxLong(shape !== 'polyline' ? latLong[0] : latLong);
                    this.model.regionsObj[title].latDetails.min = minMaxLat.lowest;
                    this.model.regionsObj[title].latDetails.max = minMaxLat.highest;
                    this.model.regionsObj[title].longDetails.min = minMaxLong.lowest;
                    this.model.regionsObj[title].longDetails.max = minMaxLong.highest;
                    this.updateLocationZone(title, layer, shape, shape !== 'polyline' ? latLong : new Array(latLong), originalLatLong)
                }
            })
        });

        this.map.on(L.Draw.Event.DELETED, (e) => {
            let layers = e.layers;
            layers.eachLayer((layer) => {
                let title;
                // let popup = layer.getPopup();
                // console.log("popup", popup)
                // layer.unbindPopup().bindPopup(popup);
                if (layer._tooltip && layer._tooltip._content) {
                    title = layer._tooltip._content;
                    this.deleteLocationZone(title);
                } else if (layer._popup && layer._popup._content) {
                    title = layer._popup._content;
                    this.deleteLocationZone(title);
                }
            });
        });
    }

    branchDetails(data) {
        this.map.setView([data.gpsLat, data.gpsLong], 11);

        let locationInfo = '<strong>' + data.branchId + '</strong>' + '<br>' +
            data.address + ' - ' + data.zip + '<br>' +
            data.city + ', ' + data.state;

        const marker = L.marker([data.gpsLat, data.gpsLong],
            {
                icon: new L.AwesomeNumberMarkers({
                    number: 'B',
                    markerColor: 'black'
                })
            })
            .addTo(this.map)
            .bindPopup(locationInfo)

        marker.on('mouseover', function () {
            marker.openPopup();
        });

        marker.on('mouseout', function () {
            marker.closePopup();
        });
    }

    updateLocationZone(title,layer, shape, latLong, originalLatLong) {
        this.model.bucketObj[title].process = true;

        // console.log('updateLocationZone = ', this.model.bucketObj[title].details.inserted_row[0].id);

        this.RegionRoutingService.updateLocationZone(this.model.loggedInUser, this.model.branch, title,
            // this.model.bucketObj[title].details.inserted_row ? this.model.bucketObj[title].details.inserted_row[0].id : null,
            this.model.bucketObj[title].locationZoneId,
            // this.model.bucketObj[title].type, 
            this.model.regionsObj[title].latDetails, this.model.regionsObj[title].longDetails, this.model.selectedDay, shape, latLong,
            this.model.bucketObj[title].pagination.pageLimit,
            (this.model.bucketObj[title].pagination.page - 1) * this.model.bucketObj[title].pagination.pageLimit)
            .then((data) => {
                this.bulkZones.push({
                    action: 'update',
                    id: this.model.bucketObj[title].locationZoneId,
                    title,
                    latDetails: this.model.regionsObj[title].latDetails,
                    longDetails: this.model.regionsObj[title].longDetails,
                    shape,
                    locationData: latLong
                    });
                this.closeBulkAlert();
                this.model.bucketObj[title].details = data;
                this.dayChanged()
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                    this.model.bucketObj[title].process = false;
                    // this.model.bucketObj = {};
                    // this.model.regionsObj = {};
                    // this.map.removeLayer(layer);
                    layer.setLatLngs(originalLatLong)
                }
            })
            .finally(() => {
                if (this.model.bucketObj[title] && this.model.bucketObj[title].process) this.model.bucketObj[title].process = false;
            })
    }

    createLocationZone(title, layer, type, latLong) {
        this.model.bucketObj[title].process = true;
        this.model.bucketObj[title].getLocations = true;

        // this.model.bucketObj[title].type

        this.RegionRoutingService.createLocationZone(this.model.loggedInUser, this.model.branch, title,
            // this.model.bucketObj[title].type, 
            this.model.regionsObj[title].latDetails, this.model.regionsObj[title].longDetails, this.model.selectedDay, type, latLong,
            this.model.bucketObj[title].pagination.pageLimit,
            (this.model.bucketObj[title].pagination.page - 1) * this.model.bucketObj[title].pagination.pageLimit)
            .then((data) => {
                this.bulkZones.push({
                    action: 'create',
                    title,
                    latDetails: this.model.regionsObj[title].latDetails,
                    longDetails: this.model.regionsObj[title].longDetails,
                    shape: type,
                    locationData: latLong 
                });
                this.closeBulkAlert();
                this.model.bucketObj[title].details = data;
                this.model.bucketObj[title].zone = title;
                data.inserted_row.forEach((d) => {
                    this.model.bucketObj[title].locationZoneId = d.id;
                })
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                    this.model.bucketObj[title].process = false;
                    this.model.bucketObj[title].getLocations = false;
                    // this.model.bucketObj = {};
                    // this.model.regionsObj = {};
                    this.map.removeLayer(layer);
                    // delete this.model.bucketObj[title];
                }
            })
            .finally(() => {
                this.dayChanged();
                if (this.model.bucketObj[title] && this.model.bucketObj[title].process) {
                    this.model.bucketObj[title].process = false;
                    this.model.bucketObj[title].getLocations = false;
                }
            })
    }

    getLocations(title) {
        this.model.bucketObj[title].process = true;
        const searchText = this.model.bucketObj[title].searchText;

        this.RegionRoutingService.getLocations(title, this.model.regionsObj[title].latDetails, this.model.regionsObj[title].longDetails, this.model.branch, searchText,
            this.model.bucketObj[title].pagination.pageLimit, (this.model.bucketObj[title].pagination.page - 1) * this.model.bucketObj[title].pagination.pageLimit,
            this.model.bucketObj[title].actualLatLong)
            .then((data) => {
                this.model.bucketObj[title].details = data;
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.bucketObj[title].process = false;
            })
    }

    search(title){
        this.model.bucketObj[title].pagination.page = 1;
        this.getLocations(title);
    }

    findMinMaxLat(array) { // TODO: better solution for this
        if (array.length === 0) {
            return { lowest: null, highest: null };
        }

        let lowest = Number.POSITIVE_INFINITY;
        let highest = Number.NEGATIVE_INFINITY;

        array.forEach(coord => {
            if (coord.lat < lowest) {
                lowest = coord.lat;
            }
            if (coord.lat > highest) {
                highest = coord.lat;
            }
        });
        return { lowest, highest };
    }

    findMinMaxLong(array) { // TODO: better solution for this
        if (array.length === 0) {
            return { lowest: null, highest: null };
        }

        let lowest = Number.POSITIVE_INFINITY;
        let highest = Number.NEGATIVE_INFINITY;

        array.forEach(coord => {
            if (coord.lng < lowest) {
                lowest = coord.lng;
            }
            if (coord.lng > highest) {
                highest = coord.lng;
            }
        });

        return { lowest, highest };
    }

    // findMinMaxLong(array) { // TODO: better solution for this
    //     let lowest = Number.NEGATIVE_INFINITY;
    //     let highest;
    //     for (let i = array.length - 1; i >= 0; i--) {
    //         let tmp = array[i].lng;
    //         if (tmp > lowest) highest = tmp;
    //     }
    //     lowest = _.min(array, 'lng');
    //     return { lowest: highest, highest: lowest.lng };
    // }

    dayChanged() {
        if (!this.model.selectedDay) return;
        this.loadinglocationZone = true;
        this.model.bucketObj = {};
        this.RegionRoutingService.getDayWiseLocationZone(this.model.branch, this.model.selectedDay)
            .then((data) => {
                this.results = data.locationZoneResult;
                this.editableLayers.clearLayers(); // Clear existing layers

                data.locationZoneResult.forEach(obj => {
                    this.model.bucketObj[obj.name] = {
                        pagination: {
                            page: 1,
                            total: 0,
                            pageLimit: 10,
                            maxPages: 10
                        },
                        gettingBranch: false,
                        searchText: null,
                        process: false,
                        type: obj.shape,
                        details: {
                            results: obj.locationDetails,
                            total: obj.totalLocationRecords
                        },
                        locationZoneId: obj.id,
                        zone: obj.name,
                        actualLatLong: obj.locationData[obj.name].latLong,
                        ruleAssignments: [],
                        savedRuleCount: (obj.rules || []).length,
                        showRuleAssignments: false
                    }

                    this.model.regionsObj[obj.name] = {
                        latDetails: {
                            min: obj.latMin,
                            max: obj.latMax

                        },
                        longDetails: {
                            min: obj.lonMin,
                            max: obj.lonMax
                        }
                    };

                    let layer, latLngs;
                    if (obj.shape === null) return
                    else if (obj.shape === 'rectangle') {
                        latLngs = obj.locationData[obj.name].latLong;
                        layer = L.rectangle(latLngs).addTo(this.editableLayers);
                        layer.bindPopup(obj.name, { autoClose: false }).openPopup();
                    }
                    else if (obj.shape === 'polygon') {
                        latLngs = obj.locationData[obj.name].latLong;
                        layer = L.polygon(latLngs).addTo(this.editableLayers);
                        layer.bindPopup(obj.name, { autoClose: false }).openPopup();
                    }
                    else if (obj.shape === 'polyline') {
                        latLngs = obj.locationData[obj.name].latLong;
                        layer = L.polyline(latLngs).addTo(this.editableLayers)
                        layer.bindPopup(obj.name, { autoClose: false }).openPopup();
                    }
                })

                this.locationZoneCountObj[this.model.selectedDay] = { totalRecords: data.totalCount }
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.loadinglocationZone = false;
            })
    }


    deleteLocationZone(title) {
        this.deletingServiceZone = true;
        this.RegionRoutingService.deleteLocationZone(this.model.bucketObj[title].locationZoneId, title, this.model.branch)
            .then(() => {
                this.dayChanged();
                this.bulkZones.push({
                    action: 'delete',
                    name: title,
                    branchId: this.model.branch
                });
                this.closeBulkAlert();
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.deletingServiceZone = false;
            })
    }

    getLocationZoneCount() {
        this.countLocationZone = true;
        this.locationZoneCountObj = {};
        this.RegionRoutingService.getLocationZoneCount(this.model.branch)
            .then((data) => {
                data.locationZoneResult.forEach(obj => {
                    this.locationZoneCountObj[obj.dayOfWeek] = { totalRecords: obj.count }
                })
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.countLocationZone = false;
            })
    }
};

export default DeliveryRegionRoutingCreateController;



// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/create/delivery_region_routing.create.controller.js